import { usePaymentOverdueModal } from '@/components/PaymentInstructionModal/usePaymentOverdueModal';
import { removeTokens } from '@/core/helpers';
import {
  setAmazonDataImportStatus,
  setHasNewAmazonCredentials,
} from '@/core/store/amazon/amazonSlice';
import { clearUserState } from '@/core/store/user/userSlice';
import { useNavigate } from 'react-router';
import { useAppDispatch } from './useReduxToolkit';

export function useLogout() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { closeModal } = usePaymentOverdueModal();

  const onLogoutClick = () => {
    sessionStorage.clear();
    dispatch(clearUserState());
    dispatch(setAmazonDataImportStatus(undefined));
    dispatch(setHasNewAmazonCredentials(false));
    closeModal();
    removeTokens();
    navigate('/');
  };

  return { onLogoutClick };
}
